module.exports = __webpack_public_path__ + "img/chinesecompany214.1f19a732.png";